import { AxiosInstance, AxiosRequestConfig } from 'axios';

const generateRequestId = (): string => {
    const c: any = typeof crypto !== 'undefined' ? crypto : undefined;
    if (c && typeof c.randomUUID === 'function') {
        return c.randomUUID();
    }
    return `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
};

export const attachRequestId = (instance: AxiosInstance) => {
    instance.interceptors.request.use((config: AxiosRequestConfig) => {
        if (!config.headers) {
            config.headers = {};
        }
        (config.headers as any)['X-Request-Id'] = generateRequestId();
        return config;
    });
};
